import {
  CKBox,
  CKLayoutHorizontal,
  CKMultilineTextFieldNext,
  CKSkeleton,
  CKTextFieldNext,
} from 'clearkit';

import UpgradePlanItem from './UpgradePlanItem';

export type ContactValues = {
  email: string;
  name: string;
  credits: boolean;
  enrichmentData: boolean;
  prospecting: boolean;
  message?: string;
};

type RequestAccessFormProps = {
  isLoading: boolean;
  onChange: (key: string) => (value: string | boolean) => void;
  values: ContactValues;
};

export function FormContact({
  isLoading,
  onChange,
  values,
}: RequestAccessFormProps) {
  return (
    <CKBox className="p-6 space-y-6 divide-y divide-gray-200">
      <CKLayoutHorizontal className="h-[62.5px]">
        <CKSkeleton className="h-full grow" isLoading={isLoading}>
          <CKTextFieldNext
            className="grow"
            isRequired
            onChange={onChange('email')}
            value={values.email as string}
          >
            <CKTextFieldNext.Label>Email address</CKTextFieldNext.Label>
          </CKTextFieldNext>
        </CKSkeleton>
        <CKSkeleton className="h-full grow" isLoading={isLoading}>
          <CKTextFieldNext
            className="grow"
            isRequired
            onChange={onChange('name')}
            value={values.name as string}
          >
            <CKTextFieldNext.Label>Name</CKTextFieldNext.Label>
          </CKTextFieldNext>
        </CKSkeleton>
      </CKLayoutHorizontal>

      <div className="py-6 space-y-6">
        <h3 className="font-medium">
          Optional: What are you interested in? Check all that apply.
        </h3>
        <div className="grid gap-4">
          <UpgradePlanItem
            checked={values.prospecting}
            onChange={onChange('prospecting')}
            title="Discover & export prospects with Clearbit Prospector"
          >
            Build your pipeline: Find prospects in Clearbit’s rich Prospector
            dataset, and export them to your CRM or to CSV.
          </UpgradePlanItem>
          <UpgradePlanItem
            checked={values.enrichmentData}
            onChange={onChange('enrichmentData')}
            title="Automatically syncing enrichment data to your CRM or MAP"
          >
            Send enriched company and contact data to available integrations
            like Salesforce, HubSpot, and more.
          </UpgradePlanItem>
          <UpgradePlanItem
            checked={values.credits}
            onChange={onChange('credits')}
            title="Additional enrichment export credits"
          >
            Sometimes we need a little more to do what we want to do.{' '}
          </UpgradePlanItem>
        </div>
      </div>
      <section className="py-6">
        <h3 className="mb-1 font-medium">Optional: Add a message</h3>
        <p>
          Don't see what you're looking for? That's ok. Let us know anything
          else you'd like to share around what you're aiming to do, and we'll
          get in touch!
        </p>
        <CKMultilineTextFieldNext
          className="mt-4"
          data-testid="message"
          onChange={onChange('message')}
          placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
          rel="message"
          rows={5}
          value={values.message as string}
        />
      </section>
    </CKBox>
  );
}
